// src/lib/productEvents.ts
//
// track(): schreibt ein Produkt-Event serverseitig nach Supabase `product_events`
// (propora-cac-dashboard liest das fuer die Growth-Diagnostics User-Journey).
// Laeuft NEBEN dataLayer.push() her, nicht
// statt dessen -- dieselben Event-Namen, zwei Aufrufstellen (siehe
// useTrackingEvents.ts), damit es weiterhin genau eine fachliche
// Event-Definition pro Aktion gibt.
//
// Harte Vorgaben (Entscheidung 01.10.):
// - KEINE PII in properties -- nur IDs/Typen (analyzer_type, tool_name, source).
// - track() darf NIE die UI blockieren oder einen Fehler werfen: komplett
//   fire-and-forget, alle Fehler landen nur in console.warn.
//
// Holt den Clerk-Token ueber window.Clerk (vom @clerk/clerk-react-Provider
// global gesetzt, siehe node_modules/@clerk/clerk-react/dist/index.js
// "global.Clerk = c") statt ueber den useAuth()-Hook, damit trackXxx() als
// einfache Funktion von ueberall aufrufbar bleibt (Analyzer-Routen,
// Button-Handler, Effects) -- exakt wie die bestehenden trackXxx()-Funktionen
// in useTrackingEvents.ts, die ebenfalls keine Hooks sind.

import { metaMatchingContext } from "./metaMatching";

declare global {
  interface Window {
    Clerk?: {
      session?: { getToken: () => Promise<string | null> } | null;
    };
  }
}

export type ProductEventName =
  | "session_started"
  | "analysis_started"
  | "analysis_step_completed"
  | "analysis_completed"
  | "tool_used"
  | "pricing_viewed"
  | "upgrade_clicked"
  | "result_viewed"
  | "checkout_started"
  // Gefuehrter Ablauf nach /check (PHASE-4-BEFUND.md Runde 1, /deal/:id): Schritt im
  // Hebel-/Vertiefen-/Entscheiden-Bereich geoeffnet bzw. einzelne Interaktion darin.
  | "deal_flow_step_viewed"
  | "deal_flow_action_clicked";

export type ProductEventProperties = Record<string, string | number | boolean>;

export function track(event: ProductEventName, properties: ProductEventProperties = {}): void {
  if (typeof window === "undefined") return;

  (async () => {
    try {
      const token = await window.Clerk?.session?.getToken();
      if (!token) return; // nicht eingeloggt -- kein product_event ohne user_id

      await fetch("/api/session-status", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ action: "track", event, properties, meta: metaMatchingContext() }),
        keepalive: true,
      });
    } catch (err) {
      // Analytics darf nie die App blockieren oder sichtbar fehlschlagen.
      console.warn("[track] product_event fehlgeschlagen (ignoriert):", err);
    }
  })();
}
